// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================== */
/*        SCSS VARS       */
/* ===================== */
/* ===================== */
/*      CSS VARIABLES     */
/* ===================== */
:root {
  /* Text */
  --base-text-color: #1D1D1D;
  --darker-text-color: #202020;
  --brighter-text-color: #696969;
  /* UI */
  --base-ui-color: #1351F1;
  --warning-ui-color: #F8A01E;
  --secondary-ui-color: #E8E4E4;
  /* Background */
  --base-bg-color: #F5F5F5;
  /* Grays */
  --color-gray: #B2B2B2;
  --color-gray-2: #9E9E9E;
  --color-gray-3: #D8D8D8;
  --color-dark-gray: #676767;
  /* Fonts */
  --main-font: Noto Sans;
  --secondary-font: Roboto;
  --third-font: Open Sans;
  --fourth-font: Dosis;
  /* Error */
  --error-color: #E00000;
  /* Border */
  --border-color: #D8D8D8;
}

.fk-table {
  border-collapse: collapse !important;
}
.fk-table .collapsed-data .fk-table-cell.--first {
  padding: 0 !important;
}
.fk-table .collapsed-data .fk-table-cell.--first .collapse {
  background-color: #fff;
  border-style: solid;
  border-color: #1351F1;
  border-width: 0 1px 1px 1px;
  padding: 15px;
  margin-bottom: 30px;
}
.fk-table .fk-table-head tr {
  vertical-align: top;
  height: 50px;
}
.fk-table .fk-table-head th, .fk-table .fk-table-head th span {
  font: normal normal bold 14px/17px Dosis;
  color: #B9B9B9;
}
.fk-table .fk-table-cell {
  height: inherit;
  padding: 5px 0;
}
.fk-table .fk-table-cell .value {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 15px;
  background-color: #FFFFFF;
  font: normal normal normal 18px/22px Dosis;
  color: #434343;
  text-overflow: ellipsis;
  overflow: hidden;
}
.fk-table .fk-table-cell .value.error {
  color: #E00000;
}
.fk-table .fk-table-cell .value svg:hover {
  opacity: 0.8;
  cursor: pointer;
}
.fk-table .fk-table-cell .value button {
  border: none;
  background: none;
  font-size: 15px;
}
.fk-table .fk-table-cell .value button:hover {
  opacity: 0.8;
  cursor: pointer;
}
.fk-table .fk-table-cell .value .alert {
  color: #E00000;
  font-size: 24px;
  line-height: 15px;
  padding-right: 5px;
}
.fk-table .fk-table-cell.--first .value {
  border-radius: 5px 0 0 5px;
}
.fk-table .fk-table-cell.--last .value {
  border-radius: 0 5px 5px 0;
}
.fk-table .fk-table-cell.crud {
  width: 150px;
}
.fk-table .fk-table-cell.crud .value button {
  font: normal normal normal 18px/22px Dosis;
}
.fk-table .MuiTableRow-root.row {
  height: 1px;
}
.fk-table .MuiTableRow-root.row.collapsed-data .fk-table-cell {
  color: unset !important;
}
.fk-table .MuiTableRow-root.row.collapsed-data .fk-table-cell .value {
  border-color: transparent !important;
  background-color: unset !important;
  color: unset !important;
}
.fk-table .MuiTableRow-root.row:hover .fk-table-cell, .fk-table .MuiTableRow-root.row.active .fk-table-cell {
  color: #1351F1;
  padding: 4px 0;
}
.fk-table .MuiTableRow-root.row:hover .fk-table-cell .value, .fk-table .MuiTableRow-root.row.active .fk-table-cell .value {
  border-style: solid;
  border-color: #1351F1;
  border-width: 1px 0;
  background-color: #ECF5EC;
  color: #1351F1;
}
.fk-table .MuiTableRow-root.row:hover .fk-table-cell .value.error, .fk-table .MuiTableRow-root.row.active .fk-table-cell .value.error {
  color: #E00000 !important;
}
.fk-table .MuiTableRow-root.row:hover .fk-table-cell.--first .value, .fk-table .MuiTableRow-root.row.active .fk-table-cell.--first .value {
  border-left-width: 1px;
  padding-left: 14px;
}
.fk-table .MuiTableRow-root.row:hover .fk-table-cell.--last .value, .fk-table .MuiTableRow-root.row.active .fk-table-cell.--last .value {
  border-right-width: 1px;
  padding-right: 9px;
}
.fk-table .MuiTableRow-root.row:hover .fk-table-cell.crud .value button, .fk-table .MuiTableRow-root.row.active .fk-table-cell.crud .value button {
  color: #1351F1;
}
.fk-table .MuiTableRow-root.row.active .fk-table-cell {
  padding-bottom: 0;
}
.fk-table .MuiTableRow-root.row.active .fk-table-cell.--first .value {
  border-radius: 5px 0 0 0;
}
.fk-table .MuiTableRow-root.row.active .fk-table-cell.--last .value {
  border-radius: 0 5px 0 0;
}
.fk-table .MuiTableRow-root.row.active .fk-table-cell.crud .value {
  margin-bottom: 0;
}
.fk-table .MuiTableCell-root {
  padding: 5px 0;
  border-bottom: none;
}
.fk-table .MuiTableCell-root.MuiTableCell-paddingCheckbox {
  padding: 0 !important;
}
.fk-table .MuiTableCell-root.MuiTableCell-head {
  padding-left: 15px;
}

.fk-no-items {
  font: normal normal normal 14px/17px "Dosis";
  color: #434343;
  font-size: 20px;
  text-align: center;
  padding: 25px 50px;
}

.fk-pagination {
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
}
.fk-pagination.--flex-end {
  justify-content: flex-end;
}
.fk-pagination button {
  padding: 10px 15px;
  font: normal normal normal 14px/18px Dosis;
  text-transform: none;
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/components/table/table.styles.scss"],"names":[],"mappings":"AAAA,0BAAA;AACA,2BAAA;AACA,0BAAA;AA2BA,0BAAA;AACA,2BAAA;AACA,0BAAA;AAEA;EACE,SAAA;EACA,0BAAA;EACA,4BAAA;EACA,8BAAA;EAEA,OAAA;EACA,wBAAA;EACA,2BAAA;EACA,6BAAA;EAEA,eAAA;EACA,wBAAA;EAEA,UAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,0BAAA;EAEA,UAAA;EACA,sBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EAEA,UAAA;EACA,sBAAA;EAEA,WAAA;EACA,uBAAA;AChCF;;AA7BA;EACI,oCAAA;AAgCJ;AA5BY;EACI,qBAAA;AA8BhB;AA5BgB;EACI,sBAAA;EACA,mBAAA;EACA,qBDLJ;ECMI,2BAAA;EACA,aAAA;EACA,mBAAA;AA8BpB;AAtBQ;EACI,mBAAA;EACA,YAAA;AAwBZ;AArBQ;EACI,wCAAA;EACA,cAAA;AAuBZ;AAnBI;EACI,eAAA;EACA,cAAA;AAqBR;AAlBQ;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,0CAAA;EACA,cAAA;EACA,uBAAA;EAEA,gBAAA;AAmBZ;AAjBY;EACI,cD9BF;ACiDd;AAfgB;EACI,YAAA;EACA,eAAA;AAiBpB;AAbY;EACI,YAAA;EACA,gBAAA;EACA,eAAA;AAehB;AAbgB;EACI,YAAA;EACA,eAAA;AAepB;AAXY;EACI,cDpDF;ECqDE,eAAA;EACA,iBAAA;EACA,kBAAA;AAahB;AARY;EACI,0BAAA;AAUhB;AALY;EACI,0BAAA;AAOhB;AAHQ;EACI,YAAA;AAKZ;AAFgB;EACI,0CAAA;AAIpB;AAGQ;EACI,WAAA;AADZ;AAIgB;EACI,uBAAA;AAFpB;AAIoB;EACI,oCAAA;EACA,kCAAA;EACA,uBAAA;AAFxB;AASgB;EACI,cDrHJ;ECsHI,cAAA;AAPpB;AASoB;EACI,mBAAA;EACA,qBD1HR;EC2HQ,mBAAA;EACA,yBAAA;EACA,cD7HR;ACsHhB;AASwB;EACI,yBAAA;AAP5B;AAYwB;EACI,sBAAA;EACA,kBAAA;AAV5B;AAewB;EACI,uBAAA;EACA,kBAAA;AAb5B;AAmB4B;EACI,cDrJhB;ACoIhB;AAyBgB;EACI,iBAAA;AAvBpB;AA0BwB;EACI,wBAAA;AAxB5B;AA6BwB;EACI,wBAAA;AA3B5B;AAgCwB;EACI,gBAAA;AA9B5B;AAsCI;EACI,cAAA;EACA,mBAAA;AApCR;AAsCQ;EACI,qBAAA;AApCZ;AAuCQ;EACI,kBAAA;AArCZ;;AA0CA;EACI,4CAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAvCJ;;AA0CA;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;AAvCJ;AAyCI;EACI,yBAAA;AAvCR;AA0CI;EACI,kBAAA;EACA,0CAAA;EACA,oBAAA;AAxCR","sourcesContent":["/* ===================== */\n/*        SCSS VARS       */\n/* ===================== */\n\n$base-text-color: #1D1D1D;\n$darker-text-color: #202020;\n$brighter-text-color: #696969;\n\n$base-ui-color: #1351F1;\n$warning-ui-color: #F8A01E;\n$secondary-ui-color: #E8E4E4;\n\n$base-bg-color: #F5F5F5;\n\n$color-gray: #B2B2B2;\n$color-gray-2: #9E9E9E;\n$color-gray-3: #D8D8D8;\n$color-dark-gray: #676767;\n\n$main-font: \"Noto Sans\";\n$secondary-font: \"Roboto\";\n$third-font: \"Open Sans\";\n$fourth-font: \"Dosis\";\n\n$error-color: #E00000; // #ff1744\n\n$border-color: #D8D8D8;\n\n\n/* ===================== */\n/*      CSS VARIABLES     */\n/* ===================== */\n\n:root {\n  /* Text */\n  --base-text-color: #{$base-text-color};\n  --darker-text-color: #{$darker-text-color};\n  --brighter-text-color: #{$brighter-text-color};\n\n  /* UI */\n  --base-ui-color: #{$base-ui-color};\n  --warning-ui-color: #{$warning-ui-color};\n  --secondary-ui-color: #{$secondary-ui-color};\n\n  /* Background */\n  --base-bg-color: #{$base-bg-color};\n\n  /* Grays */\n  --color-gray: #{$color-gray};\n  --color-gray-2: #{$color-gray-2};\n  --color-gray-3: #{$color-gray-3};\n  --color-dark-gray: #{$color-dark-gray};\n\n  /* Fonts */\n  --main-font: #{$main-font};\n  --secondary-font: #{$secondary-font};\n  --third-font: #{$third-font};\n  --fourth-font: #{$fourth-font};\n\n  /* Error */\n  --error-color: #{$error-color};\n\n  /* Border */\n  --border-color: #{$border-color};\n}","@import '../../styles/variables';\n\n.fk-table {\n    border-collapse: collapse !important;\n\n    .collapsed-data {\n        .fk-table-cell {\n            &.--first {\n                padding: 0 !important;\n\n                .collapse {\n                    background-color: #fff;\n                    border-style: solid;\n                    border-color: $base-ui-color;\n                    border-width: 0 1px 1px 1px;\n                    padding: 15px;\n                    margin-bottom: 30px;\n                }\n            }\n        }\n    }\n\n    .fk-table-head {\n\n        tr {\n            vertical-align: top;\n            height: 50px;\n        }\n\n        th, th span {\n            font: normal normal bold 14px/17px Dosis;\n            color: #B9B9B9;\n        }\n    }\n\n    .fk-table-cell {\n        height: inherit;\n        padding: 5px 0;\n\n\n        .value {\n            display: flex;\n            align-items: center;\n            width: 100%;\n            height: 100%;\n            padding: 15px;\n            background-color: #FFFFFF;\n            font: normal normal normal 18px/22px Dosis;\n            color: #434343;\n            text-overflow: ellipsis;\n            // white-space: nowrap;\n            overflow: hidden;\n\n            &.error {\n                color: $error-color;\n            }\n\n            svg {\n                &:hover {\n                    opacity: .8;\n                    cursor: pointer;\n                }\n            }\n\n            button {\n                border: none;\n                background: none;\n                font-size: 15px;\n\n                &:hover {\n                    opacity: .8;\n                    cursor: pointer;\n                }\n            }\n\n            .alert {\n                color: $error-color;\n                font-size: 24px;\n                line-height: 15px;\n                padding-right: 5px;\n            }\n        }\n\n        &.--first {\n            .value {\n                border-radius: 5px 0 0 5px;\n            }\n        }\n\n        &.--last {\n            .value {\n                border-radius: 0 5px 5px 0;\n            }\n        }\n\n        &.crud {\n            width: 150px;\n\n            .value {\n                button {\n                    font: normal normal normal 18px/22px Dosis;\n                }\n            }\n        }\n    }\n\n    .MuiTableRow-root {\n        &.row {\n            height: 1px;\n\n            &.collapsed-data {\n                .fk-table-cell {\n                    color: unset !important;\n\n                    .value {\n                        border-color: transparent !important;\n                        background-color: unset !important;\n                        color: unset !important;\n                    }\n                }\n            }\n\n            &:hover,\n            &.active {\n                .fk-table-cell {\n                    color: $base-ui-color;\n                    padding: 4px 0;\n\n                    .value {\n                        border-style: solid;\n                        border-color: $base-ui-color;\n                        border-width: 1px 0;\n                        background-color: #ECF5EC;\n                        color: $base-ui-color;\n\n                        &.error {\n                            color: $error-color !important;\n                        }\n                    }\n\n                    &.--first {\n                        .value {\n                            border-left-width: 1px;\n                            padding-left: 14px;\n                        }\n                    }\n\n                    &.--last {\n                        .value {\n                            border-right-width: 1px;\n                            padding-right: 9px;\n                        }\n                    }\n\n                    &.crud {\n                        .value {\n                            button {\n                                color: $base-ui-color;\n                            }\n                        }\n                    }\n                }\n            }\n\n            &.active {\n                .fk-table-cell {\n                    padding-bottom: 0;\n\n                    &.--first {\n                        .value {\n                            border-radius: 5px 0 0 0;\n                        }\n                    }\n\n                    &.--last {\n                        .value {\n                            border-radius: 0 5px 0 0;\n                        }\n                    }\n\n                    &.crud {\n                        .value {\n                            margin-bottom: 0;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .MuiTableCell-root {\n        padding: 5px 0;\n        border-bottom: none;\n\n        &.MuiTableCell-paddingCheckbox {\n            padding: 0 !important;\n        }\n\n        &.MuiTableCell-head {\n            padding-left: 15px;\n        }\n    }\n}\n\n.fk-no-items {\n    font: normal normal normal 14px/17px $fourth-font;\n    color: #434343;\n    font-size: 20px;\n    text-align: center;\n    padding: 25px 50px;\n}\n\n.fk-pagination {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 32px;\n\n    &.--flex-end {\n        justify-content: flex-end;\n    }\n\n    button {\n        padding: 10px 15px;\n        font: normal normal normal 14px/18px Dosis;\n        text-transform: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
